/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Metadata
 * @desc Metadata filter
 */

import { FilterMetadataForm } from 'labstep-web/components/FilterPost/NewIndex/Metadata/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Metadata } from 'labstep-web/models/metadata';
import type React from 'react';
import type { FilterPostNewIndexMetadataProps } from './types';

const metadataNameCapitalised = Metadata.getHumanReadableEntityName(
  false,
  true,
);

export const FilterPostNewIndexMetadata: React.FC<
  FilterPostNewIndexMetadataProps
> = ({ path, addPostFilter, defaultValues, replace, ...rest }) => (
  <Modal
    header={`Filter by ${metadataNameCapitalised}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterMetadataForm
        addPostFilter={addPostFilter}
        path={path}
        onDone={toggleModal}
        defaultValues={defaultValues}
        replace={replace}
      />
    )}
    {...rest}
  />
);
